import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import numeral from 'numeral';

const GET_TIMESHEET_BILLABLE_HOURS = gql`
  query getTimesheetBillableHours($timesheetId: String!) {
    reports {
      timesheet(timesheetId: $timesheetId) {
        _id
        totalHours
        billableHours
      }
    }
  }
`;

const BillableHoursCell = ({ timesheetId, totalHours }) => {
  const { loading, error, data } = useQuery(GET_TIMESHEET_BILLABLE_HOURS, {
    variables: { timesheetId },
    fetchPolicy: 'cache-first',
  });

  if (loading) {
    return (
      <div>
        <div>{totalHours}</div>
      </div>
    );
  }

  if (error) {
    return <div>{totalHours}</div>;
  }

  const billableHours = data?.reports?.timesheet?.billableHours || 0;
  const nonBillableHours = totalHours - billableHours;

  return (
    <div>
      <div>{numeral(totalHours).format('0.[00]')} ({numeral(billableHours).format('0.[00]')}/{numeral(nonBillableHours).format('0.[00]')})</div>
    </div>
  );
};

export default BillableHoursCell;